// extracted by mini-css-extract-plugin
module.exports = {"container":"_2byG3dcw57Xhatx-G5Qe9b","modeSwitch":"_2RJTKhmWoirzSEIAHVmkH7"};